import * as React from "react";
import { ArrowRight, Clock, MapPin, PhoneCall, ShieldCheck, Wrench } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
const serviceHighlights = [{
  title: "24/7 Emergency Dispatch",
  detail: "Rapid response across Riverdale and Clayton County"
}, {
  title: "Licensed & Insured",
  detail: "Upfront pricing with no hidden overtime fees"
}, {
  title: "Full Plumbing Solutions",
  detail: "Leaks, water heaters, clogged drains, and pipe repairs"
}];
export default function RiverdaleCta() {
  return <section id="riverdaleclosingcta" data-nav="light" className="relative overflow-hidden bg-background py-16 sm:py-20 lg:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-5xl">
          <Card className="border-border bg-card shadow-xl overflow-hidden">
            <CardContent className="p-6 sm:p-10 lg:p-12">
              <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:items-center">
                {/* Left Column: Heading and Context */}
                <div className="space-y-6 lg:col-span-7">
                  <div className="flex flex-wrap items-center gap-2">
                    <Badge variant="secondary" className="gap-1.5 px-3 py-1 text-xs">
                      <MapPin className="size-3.5 text-primary" />
                      Riverdale, GA Service Area
                    </Badge>
                    <Badge variant="outline" className="gap-1.5 px-3 py-1 text-xs">
                      <Clock className="size-3.5 text-primary" />
                      24/7 Fast Arrival
                    </Badge>
                  </div>

                  <div className="space-y-3">
                    <h2 className="font-default text-2xl font-bold tracking-tight text-foreground sm:text-3xl lg:text-4xl">
                      Need Plumbing Help in Riverdale? Contact Us Today
                    </h2>
                    <p className="font-default text-base text-muted-foreground sm:text-lg">
                      From urgent pipe bursts and water heater failures to scheduled drain cleaning, our licensed technicians are ready to restore your home plumbing safely and quickly.
                    </p>
                  </div>

                  {/* Feature Bullets */}
                  <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 pt-2">
                    {serviceHighlights.map((item, index) => <div key={item.title} data-index={index} className="rounded-lg border border-border bg-background p-3.5">
                        <div className="mb-1 flex items-center gap-2">
                          <ShieldCheck className="size-4 text-primary shrink-0" />
                          <span className="font-default text-xs font-semibold text-foreground">
                            {item.title}
                          </span>
                        </div>
                        <p className="font-default text-xs text-muted-foreground">
                          {item.detail}
                        </p>
                      </div>)}
                  </div>
                </div>

                {/* Right Column: Dual CTAs */}
                <div className="flex flex-col justify-center rounded-xl border border-border bg-background p-6 shadow-sm sm:p-8 lg:col-span-5">
                  <div className="mb-6 space-y-2 text-center lg:text-left">
                    <span className="font-default text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                      Fast Local Assistance
                    </span>
                    <p className="font-default text-xl font-bold text-foreground">
                      Speak directly with an on-duty plumbing specialist.
                    </p>
                  </div>

                  <div className="flex flex-col gap-3">
                    {/* Primary CTA - Direct Phone Call */}
                    <a href="tel:4708479076" className="block w-full">
                      <Button size="lg" className="w-full gap-2 text-base font-semibold shadow-md">
                        <PhoneCall className="size-5" />
                        Call (470) 847-9076
                      </Button>
                    </a>

                    {/* Secondary CTA - Online Request */}
                    <Link to="/contact/" className="block w-full">
                      <Button variant="outline" size="lg" className="w-full gap-2 text-base font-medium">
                        <Wrench className="size-4 text-muted-foreground" />
                        Request Service Online
                      </Button>
                    </Link>
                  </div>

                  <Separator className="my-6" />

                  {/* Back to Service Areas Hub Link */}
                  <div className="text-center">
                    <Link to="/service-areas/" className="inline-flex items-center gap-1.5 font-default text-xs font-medium text-primary hover:underline">
                      <span>Explore all Clayton County Service Areas</span>
                      <ArrowRight className="size-3.5" />
                    </Link>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}